export enum Entity {
    Accounts = "accounts",
    AccountCreditEntries = "accountCreditEntries",
    AccountFees = "accountFees",
    AccountTypes = "accountTypes",
    AuditLogEntries = "auditLogEntries",
    AuditLogCategories = "auditLogCategories",
    CallBacks = "callBacks",
    Cases = "cases",
    CaseFileCategories = "caseFileCategories",
    CaseFollowUps = "caseFollowUps",
    CaseNotes = "caseNotes",
    ChartReviewLogs = "chartReviewLogs",
    Countries = "countries",
    FollowUps = "followUps",
    Forms = "forms",
    FormCategories = "formCategories",
    FormSelectCategories = "formSelectCategories",
    FormData = "formData",
    FormDataArchives = "formDataArchives",
    FormSelects = "formSelects",
    FormTypes = "formTypes",
    Invoices = "invoices",
    NotificationConfigs = "notificationConfigs",
    Offices = "offices",
    Orders = "orders",
    Person = "person",
    PersonTypes = "personTypes",
    ProcedureTypes = "procedureTypes",
    RecoveryAppImports = "recoveryAppImports",
    Shipments = "shipments",
    ShippingMethods = "shippingMethods",
    ShippingStatuses = "shippingStatuses",
    StandardFees = "standardFees",
    Surgeries = "surgeries",
    SurgerySchedulerSurgeons = "surgerySchedulerSurgeons",
    Tenants = "tenants",
    Tissues = "tissues",
    TissueOffers = "tissueOffers",
    TissueTypes = "tissueTypes",
    Users = "users",
}
